import React, { useEffect, useRef, useState } from "react";
import { Formik, Form, connect, useFormikContext } from "formik";
import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, LinearProgress, Typography, Slide } from '@material-ui/core';
import FormField from "components/FormField";
import CardBox from "components/CardBox";
import SnackBar from "components/SnackBar";
import ReportTable from "components/ReportTable/index";
import ContainerHeader from "components/ContainerHeader";
import API from 'util/Api';
import * as Yup from "yup";
// import _ from "lodash";
import {cloneDeep, isEqual } from "lodash";

import moment from 'moment'

const getFieldValues = (fields) => {
    const values = fields.reduce((obj, item) => {
        return { ...obj, [item.key]: item.value };
    }, {});
    return values;
}

const FormConfig = connect((props)=> {
	const config = cloneDeep(props.config);
	const locations = cloneDeep(props.locations)
	const { isSubmitting } = useFormikContext();

	const prevValuesRef = useRef(null);

	useEffect(() => {
		// console.log("form_fields ___ formConfig", props.formik.values, props.config.fields.find(f => f.key === "city")?.options);

		const { type, state, city } = props.formik.values;

		// console.log("form_fields ___ prev", 'type--', type, 'state--', state, 'city--', city, 'prevVal--', prevValuesRef.current);

		// Avoid unnecessary updates
		if (!isEqual(prevValuesRef.current?.state, state)) {
			props.formik.setValues(prevValues => ({
				...prevValues,
				city: state ? prevValues.city : null,
				location: city ? prevValues.location : null
			}));
		} else if(!isEqual(prevValuesRef.current?.city, city) || !isEqual(prevValuesRef.current?.type, type)){
			props.formik.setFieldValue("location", null);
		}

		prevValuesRef.current = { type, state, city };
		
		const cityOptions = props.formik.values.state ? props.fields.find(f => f.key === "city")?.options.filter(option => option.state_id === props.formik.values.state.value) : props.fields.find(f => f.key === "city")?.options

		const userType =  type ? type.value : '';
		const tempLoc = userType === 'charging_users' ? locations.chargingLocations : 
						userType === 'valet_users' ? locations.valetLocations : 
						userType === 'parking_users' ? locations.parkingLocations : Object.values(locations).flat();
		
		const locationOptions = props.formik.values.city ? tempLoc.filter(option => option.city_id === props.formik.values.city.value) : tempLoc;

		props.setConfig(prevConfig => ({
			...config,
			fields: config.fields.map(field =>
				field.type === "datepicker" ? 
					field.key === 'start' && props.formik.values.end ? {
						...field,
						maxDate: moment(props.formik.values.end).subtract(1, "day").startOf("day").toISOString()
					} : field.key === 'end' && props.formik.values.start ? {
						...field,
						minDate: moment(props.formik.values.start).add(1, "day").startOf("day").toISOString(),
					} : field
				: field.key == 'city' ? {
					...field,
					options : cityOptions
				} : field.key == 'location' ? {
					...field,
					options : props.formik.values.type?.value === 'all' ? [] : locationOptions,
					disabled : props.formik.values.type?.value === 'all' ? true : false
				} : field
			)
		}));
	}, [props.formik.values]);

	return (
		<div className="row">
			<CardBox styleName="col-12" heading="">
				<Form>
					<div className="row">
						{props.config.fields?.map((field) => (	 
							<div className="col-md-3 col-12" key={props.key} >
								<FormField field={{ ...field, ...{ name: field.key } }} />
							</div>
						))}
					</div>
					{/* BUTTONS */}
					<div className="row mt-2">
						<div className="col-lg-6 col-sm-12 col-12">
							<Box mt="20px">
								<Box mr="10px" display="inline">
									<Button
										variant="contained"
										color="primary"
										mr="5px"
										type="submit"
										disabled={isSubmitting}
									>
										{" Submit "}
									</Button>
								</Box>
								<Box mr="10px" display="inline">
									<Button variant="outlined" color="secondary" type="reset" disabled={isSubmitting} >
										Reset
									</Button>
								</Box>
							</Box>
						</div>
					</div>
				</Form>
			</CardBox>
			{props.formik.isSubmitting &&
				<div className="col-12">
					<LinearProgress color="primary" />
					<LinearProgress color="primary" />
				</div>
			}
		</div>
	);
});

const RepeatedUsers = (props) => {
    const [config, setConfig] = useState();
	const [fields, setFields] = useState();
	const [initialValues, setInitialValues] = useState();
    const [usersData, setUsersData] = useState();
	const [locations, setLocations] = useState();
	const [snackBar, setSnackBar] = useState({ open: false, msg: "", type: "success" })

    useEffect(() => {
        API.get('repeatedUsersConfig')
        .then((res) => {
			setLocations(res.data.data.locations);
			const tempConfig = res.data.data.config;
			const values = getFieldValues(tempConfig.fields);
            setInitialValues(values);

			setFields(tempConfig.fields);
			
			setConfig(prevConfig => ({
				...tempConfig,
				fields: tempConfig.fields.map(field =>
					field.type === "datepicker" ?
						{
							...field,
							minDate: moment().subtract(90, "days").startOf("day").toISOString(),
							maxDate: moment().endOf("day").toISOString(),
						}
					: field
				),
			}));
			console.log("form_fields config", tempConfig.fields);
        })
        .catch((err) => {
            // got an error
            console.log("Please try again", err);
        })
    },[]);

	const handleSubmit = (data, form) => {
		console.log("form_fields -- submit", data);
		data.start = new Date(new Date(data.start).setHours(0, 0, 0, 0)).toISOString();
		data.end = new Date(new Date(data.end).setHours(23, 59, 59, 999)).toISOString();
		
		API.post("repeatedUsers", data)
		.then((res) => {
			form.setSubmitting(false);
			setUsersData(res.data.data);
		}).catch((err) => {
			// setSnackBar(prevState => ({...prevState,
			// 	open: true,
			// 	msg: err.response?.data?.msg ? err.response.data.msg  : 'Something went wrong',
			// 	type: "error"
			// }));
			form.setSubmitting(false);
			console.log("catch_____", err, err?.response?.data?.msg);
		});
	};


	const handleReset = (data, form) => {
		form.resetForm();
	};

    const validations = Yup.object().shape({
		start: Yup.date().required("Required"),
		end: Yup.date().required("Required"),
		type: Yup.object().required("Required"),
		state: Yup.object().nullable(),
		city: Yup.object().nullable(),
		location: Yup.object().nullable(),
	});

	console.log("form_fields", config?.fields);
    
	return (
		<div>
			<ContainerHeader title={`Repeated Users`} match={props.match} />
			{config && (
				<Formik
					onSubmit={handleSubmit}
					onReset={handleReset}
					enableReinitialize 
					initialValues={initialValues}
					validationSchema={validations}
				>
					{initialValues && 
					<FormConfig config={config} setConfig={setConfig} fields={fields} locations={locations}/>}
				</Formik>
			)}
			<React.Fragment>
				{config && usersData && (
					<ReportTable
						data={usersData}
						downloadCSVBtn={false}
						downloadReceipt={null}
						updateParkingAmount={null}
						closeBooking={null}
						tableClass={""}
					/>
				)}
			</React.Fragment>
			{/* <SnackBar
				open={snackBar.open}
				handleClose={() => {
					setSnackBar(prevState => ({...prevState, open: false, msg: "" }));
				}}
				message={snackBar.msg}
				type={snackBar.type}
			/> */}
		</div>
	);

}

export default RepeatedUsers;